import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from "./header/header.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { DefaultLayoutComponent } from "./default-layout.component";
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DmsAddImanageDocComponent } from './dms-add-imanage-doc/dms-add-imanage-doc.component';
import { DmsCreateDocComponent } from './dms-create-doc/dms-create-doc.component';
import { DmsTemplateLocationComponent } from './dms-template-location/dms-template-location.component';
import { DmsUploadDocumentComponent } from '../dms/shared/dms-upload-document/dms-upload-document.component';
import { AddDisbursementComponent } from '../shared/components/add-disbursement/add-disbursement.component';
import { CreateclientComponent } from '../shared/components/createclient/createclient.component';
import { CreatecontactComponent } from '../shared/components/createcontact/createcontact.component';
import { CreatejobComponent } from '../shared/components/createjob/createjob.component';
import { QuickTimesheetEntryPopupComponent } from '../shared/components/quick-timesheet-entry-popup/quick-timesheet-entry-popup.component';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { DmsFolderLocationComponent } from '../dms/shared/dms-folder-location/dms-folder-location.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    DefaultLayoutComponent,
    DmsAddImanageDocComponent,
    DmsCreateDocComponent,
    DmsTemplateLocationComponent
  ],
  imports: [
    CommonModule,
    /* Angular Material used in header/sidebar */
    MatMenuModule,
    MatButtonModule,
    MatTooltipModule,
    MatBadgeModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    /* Utilities */
    NgSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    RouterModule,
    ScrollingModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    GridModule,
    NgMultiSelectDropDownModule,
    MatDatepickerModule,
    // Standalone components, directives, pipes, ...
    DmsUploadDocumentComponent, AddDisbursementComponent, CreateclientComponent, CreatecontactComponent, CreatejobComponent, QuickTimesheetEntryPopupComponent, DmsFolderLocationComponent,
  ],
  exports: [
    DefaultLayoutComponent
  ]
})

export class DefaultLayoutModule {}